module.exports = __webpack_public_path__ + "static/CustomerSupport-761a9355df472022841f079ae3a2d112.png";